var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 144,
    viewBox: "0 0 119 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0073c8;fill-rule:evenodd;}.b{fill:#3eaaf3;}.c{fill:#0090ff;}.d{fill:#259cf8;}.e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,44H25a5,5,0,0,1,5,5v63a5,5,0,0,1-5,5H0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8,
    height: 8,
    rx: 4,
    transform: "translate(16 102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7646,488a15.959,15.959,0,0,1-11.621-5H7624V420h6.958l19.171-23.963,14.758-23.454a1.943,1.943,0,0,1,2.617-.646,15.017,15.017,0,0,1,5.474,20.485l-7.365,12.659A10,10,0,0,0,7672.777,420h21.342v68Z",
    transform: "translate(-7594 -371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M7632.5,439.676a8.5,8.5,0,1,1,0-17h22a8.5,8.5,0,1,1,0,17Zm0-17a8.5,8.5,0,1,1,0-17h24a8.5,8.5,0,1,1,0,17Zm0-17a8.5,8.5,0,1,1,0-17h28a8.5,8.5,0,1,1,0,17Zm0-17a8.5,8.5,0,1,1,0-17h22a8.5,8.5,0,1,1,0,17Z",
    transform: "translate(-7550 -322.676)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(37 98.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.612,7.251a1.138,1.138,0,0,0-1.617,0l-8.482,8.493L6.95,12.169a1.163,1.163,0,0,0-1.617,1.674L9.7,18.214a1.138,1.138,0,0,0,1.617,0l9.29-9.29a1.138,1.138,0,0,0,0-1.674Z",
    transform: "translate(48.021 108.463)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsCheck);
export default __webpack_public_path__ + "static/media/thumbs-check.efe57797dcb82c2fe784ec1e92ca2a97.svg";
export { ForwardRef as ReactComponent };